import { render, staticRenderFns } from "./codeModal.vue?vue&type=template&id=5ca71b2e&"
import script from "./codeModal.vue?vue&type=script&lang=js&"
export * from "./codeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports